export { ImageWithFocalPoint } from "./ImageWithFocalPoint";
